/**
 * Created by Ning Jiang on 2021-06-23.
 */

import {FlowStatePresentation} from "@nolimitcity/slot-game/bin/flowcontrol/FlowStatePresentation";
import {FlowStateController} from "@nolimitcity/slot-game/bin/flowcontrol/FlowStateController";
import {GameMode} from "@nolimitcity/slot-game/bin/flowcontrol/GameMode";
import {ReelState} from "../../core/reel/ReelState";
import {Karen} from "../Karen";
import {KarenReelController} from "../reels/KarenReelController";
import {KarenGameConfig} from "../KarenGameConfig";
import {TimelineLite} from "gsap";
import {SlotGame} from "@nolimitcity/slot-game/bin/SlotGame";
import {GameHelper} from "../../core/utils/GameHelper";
import {IBetWayWinData} from "../server/data/IKarenData";

export class NoWinAnimationState {
    public static readonly DisappointmentBanner_1 = "DisappointmentBanner_1";
    public static readonly DisappointmentBanner_2 = "DisappointmentBanner_2";
    public static readonly DisappointmentBanner_3 = "DisappointmentBanner_3";
    public static readonly DisappointmentBanner_4 = "DisappointmentBanner_4";
}

export class KarenNormalIdlePresentation implements FlowStatePresentation {
    private static nextNoWinPoster: Generator<string, string, string> = KarenNormalIdlePresentation.getNextNoPoster();
    private static _noPosters: string[] = [
        NoWinAnimationState.DisappointmentBanner_1,
        NoWinAnimationState.DisappointmentBanner_2,
        NoWinAnimationState.DisappointmentBanner_3,
        NoWinAnimationState.DisappointmentBanner_4
    ];
    private timeLine: TimelineLite;
    private triggerIntroAnim: boolean = true;
    private _noWinCounter: number = 0;
    private _check4HitWild: boolean = false;
    private _checkForXWAYS: number = 0;

    constructor() {
    }

    private static* getNextNoPoster(): Generator<string, string, string> {
        let i: number = 0;
        while (true) {
            yield this._noPosters[i % this._noPosters.length]
            i++;
        }
    }

    public checkNoWin(): void {
        if (Karen.model.parsedGameData) {
            const winRatio: number = Karen.model.parsedGameData.currentWinRatioConfig?.ratio!;
            let isBigWin: boolean = false
            if (winRatio >= KarenGameConfig.WIN_RATIOS[4].ratio) {
                isBigWin = true;
            }
            if (isBigWin || Karen.model.parsedGameData.mode != GameMode.NORMAL) this._noWinCounter = 0;
            if (Karen.model.parsedGameData.singleWin == 0) this._noWinCounter++;
            else this._noWinCounter = Math.max(0, this._noWinCounter - 2);

            if (this.check4LongHitWild()) {
                this._check4HitWild = true;
            }
            if (this.checkForXWAYSHits()) {
                this._checkForXWAYS++;
            } else {
                this._checkForXWAYS = 0;
            }
        }
    }

    public start(flowStateController: FlowStateController) {
        flowStateController.setSkipCallback(() => this.skip(flowStateController));
        this.checkNoWin();
        this.timeLine = new TimelineLite();
        const introTimeLine: TimelineLite = new TimelineLite({
            onComplete: () => {
                this.timeLine.seek("reelsAnim");
            }
        });
        if (this.triggerIntroAnim && !Karen.model.parsedInitData.isRestoreState && !SlotGame.apiPlugin.isReplay) {
            introTimeLine.add(Karen.introView.playIntroAnimation(() => {
                introTimeLine.progress(1);
            }), 0.01);
            this.timeLine.add(introTimeLine);
            this.triggerIntroAnim = false;
            if (Karen.model.parsedInitData.mode === GameMode.FREESPIN || Karen.model.parsedInitData.nextMode === GameMode.FREESPIN) {
                return;
            }
            this.timeLine.addLabel("reelsAnim", ">");
            this.timeLine.add(() => {
                for (let reelId: number = 0; reelId < KarenGameConfig.REELS_NUM; reelId++) {
                    KarenReelController.currentNumData = [2, 3, 3, 3, 3, 3];
                    Karen.reels[reelId].reelView.updateReelMask(reelId, KarenReelController.currentNumData[reelId]);
                    Karen.reels[reelId].setSymsInReel(reelId, KarenReelController.currentNumData[reelId]);
                }
            }, "reelsAnim");
            this.timeLine.add(Karen.reels[0].setUpReels(), "reelsAnim");
            //#106
            Karen.reels[5].reelView.updateWildContainer(KarenReelController.currentNumData[5], true);
        }

        Karen.reels.forEach((reel) => {
            reel.reelState = ReelState.IDLE;
        });

        if (this._noWinCounter >= 15 || this._check4HitWild || this._checkForXWAYS >= 2) {
            if (!SlotGame.autoPlayPlugin.isAutoplayRound) {
                const nextPoster: string = KarenNormalIdlePresentation.nextNoWinPoster.next().value;
                Karen.splashView.playAnimation(nextPoster);
            }
            this._noWinCounter = 0;
            this._check4HitWild = false;
            if (this._checkForXWAYS >= 2) {
                this._checkForXWAYS = 0;
            }

        }

        if (Karen.model.gameData?.nextMode != GameMode.NORMAL) {
            flowStateController.finish();
            return;
        }
        if (Karen.reel2Frame && !Karen.autoPlayPlugin.isAutoplayRound) {
            Karen.reel2Frame.enabled(true);
        }
        //#141 #148
        if (Karen.model.gameData?.nextMode === GameMode.NORMAL && !GameHelper.isFreeSpin(Karen.model.gameData?.mode) && !Karen.autoPlayPlugin.isAutoplayRound) {
            Karen.reels.forEach((reel: KarenReelController) => {
                reel.reelView.setInteractiveSymbols(true);
            });
        }
        if (!Karen.isActionSpinsActive && !GameHelper.isWinBelowStake()) {
            Karen.individualWin.start();
        }
    }

    public completeTimeline(): void {
        if (this.timeLine) {
            this.timeLine.progress(1);
            this.timeLine.pause();
            this.timeLine.kill();
        }
    }

    private async skip(flowStateController: FlowStateController): Promise<any> {
        await Karen.individualWin.stop();
        flowStateController.finish();
    }

    private check4LongHitWild(): boolean {
        let isWild: boolean = false;
        let lastReelData: string[] = Karen.model.parsedGameData.reels[5];
        lastReelData.forEach((sym: string) => {
            if (sym === "W") {
                isWild = true;
            }
        });
        if (isWild && Karen.model.parsedGameData.symbolSizes[5][Karen.model.parsedGameData.evaluatedArea[5].length - 1] === 3
            && !Karen.model.parsedGameData.isWildParticipatingInWin && this.check4LongHitWin()) {
            return true;
        }
        return false;
    }

    private check4LongHitWin(): boolean {
        let maxWinLength: number = 0;
        Karen.model.gameData.betWayWins?.forEach((winData: IBetWayWinData) => {
            maxWinLength = winData.length > maxWinLength ? winData.length : maxWinLength;
        });
        if (maxWinLength === 4) {
            return true;
        }
        return false;
    }

    private checkForXWAYSHits(): boolean {
        let xWaysCount: number = 0;
        let reelData: number[] = Karen.model.parsedGameData.xWPositions;
        reelData.forEach((pos: number) => {
            if (pos >= 0) {
                xWaysCount++;
            }
        });
        return xWaysCount === 3 && Karen.model.parsedGameData.singleWin == 0 ? true : false;
    }
}
